export enum RecordStatus {
  Undefined = 'Undefined',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
  Partner = 'In_PartnerLand_App',
  UNREL = 'UNREL',
  REL = 'REL',
  IAPP = 'IAPP',
  FAPP = 'FAPP',
  IHLP = 'IHLP',
  IREJ = 'IREJ',
  ROUTED = 'ROUTED',
  REJT = 'REJT'
}